var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column items-center justify-center absolute inset-0",class:!_vm.tightBg && 'bg-black-3'},[_c('Spinner',{class:_vm.tightBg && ['absolute', 'inset-0', 'm-auto', 'bg-black', 'rounded-full']}),(_vm.$slots.default)?_c('div',{staticClass:"mt-4 text-center"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }